module.exports = __webpack_public_path__ + "img/banner_1.ed940b8b.png";